import React, { useState } from 'react';
import { Send, X } from 'lucide-react';
import Modal from './Modal';

const MessageModal = ({ isOpen, onClose, recipientEmail, currentUserRole, onSend }) => {
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [sending, setSending] = useState(false);

  const handleSend = async () => {
    if (!message.trim() || !subject.trim()) {
      return;
    }
    setSending(true);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 500));
    if (onSend) {
      onSend({ recipientEmail, subject, message });
    }
    setSending(false);
    handleClose();
  };

  const handleClose = () => {
    setMessage('');
    setSubject('');
    onClose();
  };

  // Trainees cannot send messages
  const canSendMessage = currentUserRole === 'Administrator' || currentUserRole === 'Instructor';

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`Send Message to ${recipientEmail}`}
      size="md"
      footer={
        <>
          <button className="btn btn-ghost" onClick={handleClose}>
            <X size={14} /> Cancel
          </button>
          {canSendMessage && (
            <button
              className="btn btn-primary"
              onClick={handleSend}
              disabled={sending || !message.trim() || !subject.trim()}
            >
              <Send size={14} /> {sending ? 'Sending...' : 'Send Message'}
            </button>
          )}
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
        {!canSendMessage ? (
          <div className="empty-state">
            <p>Trainees cannot send messages. Please contact an administrator or instructor.</p>
          </div>
        ) : (
          <>
            <div className="form-group">
              <label className="form-label">To</label>
              <input
                className="form-input"
                type="email"
                value={recipientEmail}
                readOnly
                disabled
              />
            </div>
            <div className="form-group">
              <label className="form-label">Subject *</label>
              <input
                className="form-input"
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Enter message subject"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Message *</label>
              <textarea
                className="form-textarea"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message here..."
              />
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default MessageModal;